import React, { useContext, useEffect } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import ICart from "../../../models/ICart";
import SocketService from "../../../services/SocketService";
import { Stripe, StripeElements } from "@stripe/stripe-js";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    cart: ICart;
    isCartValid: boolean;
    setPaymentFormRef: (formRef: any) => void;
    setStripe: (stripe: Stripe | null) => void;
    setElements: (elements: StripeElements | null) => void;
};

export const EcommerceStripeCardForm: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);

    const stripe = useStripe();
    const elements = useElements();

    useEffect(() => {
        console.log("stripe", stripe);
        props.setStripe(stripe);
    }, [stripe]);

    useEffect(() => {
        console.log("elements", elements);
        props.setElements(elements);
    }, [elements]);

    useEffect(() => {
        console.log("elements", elements, "stripe", stripe);
        props.setElements(elements);
        props.setStripe(stripe);
    }, []);

    const handleSubmit = async (event: any) => {
        event.preventDefault();

        console.log("handleSubmit");

        if (!stripe || !elements) {
            return;
        }

        // first before submitting we need to validate the inventory in the cart.

        const apiUrl = SocketService.getApiEndpointURl();

        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${apiUrl}/stripe-complete-checkout/${props.cart.guid}`,
            },
            // redirect: "if_required"
        });

        console.log("submit!!!", result);
    };

    return (
        <div className={"EcommerceStripeCardForm"}>
            <form
                name={"paymentForm"}
                id={"paymentForm"}
                onSubmit={handleSubmit}
                ref={(formRef) => {
                    props.setPaymentFormRef(formRef);
                }}>
                <PaymentElement />
            </form>
        </div>
    );
};
